module.exports = __webpack_public_path__ + "img/success.dcc9742.png";